// Reserve the actual control footprint, including wrapped tag rows and the
// floating navigation, so fitBounds frames whole markers, not just their anchors.
export function tagFitPadding(map) {
  const container = map.getContainer?.();
  const section = container?.closest('[data-testid="map-section"]');
  if (!section) return { top: 130, bottom: 90, left: 44, right: 44 };
  const rect = container.getBoundingClientRect();
  const controls = section.querySelectorAll(
    '[data-testid="map-selected-tags-overlay"], [data-testid="map-minimize-button"]',
  );
  const controlsBottom = Math.max(0, ...Array.from(controls, (el) => (
    el.getBoundingClientRect().bottom - rect.top
  )));
  const nav = document.querySelector('[data-testid="guest-bottom-nav"]');
  const navOverlap = nav ? Math.max(0, rect.bottom - nav.getBoundingClientRect().top) : 66;
  return {
    top: Math.min(controlsBottom + 68, rect.height * 0.45),
    bottom: Math.min(Math.max(90, navOverlap + 24), rect.height * 0.25),
    left: 44,
    right: 44,
  };
}